import useWarningsTolerance from 'hooks/useWarningsTolerance'
import { useMemo } from 'react'
import type { ClockInTeamMember } from 'screens/Rostering/types'
import { getDurationWarnings } from '../RotaDrawer/components/DrawerStatus/utils'

const useDurationWarnings = (warnings: ClockInTeamMember['warnings']) => {
  const warningsTolerance = useWarningsTolerance()

  // biome-ignore lint/correctness/useExhaustiveDependencies: pre-existing dependency list; changing when this re-runs needs behavioural review
  const durationWarnings = useMemo(
    () => getDurationWarnings(warnings, warningsTolerance),
    [warnings]
  )

  return durationWarnings
}

export default useDurationWarnings
